import { InternalAxiosRequestConfig } from 'axios';
import { cloneDeep } from 'lodash';

import { isInCapacitorApp } from '@/utils/device';
import { secureStorageGet } from '@/utils/native/nativeBridge';

export default async function getRequestConfig(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
  const requestConfig = cloneDeep(config);
  const isMobile = isInCapacitorApp();

  if (requestConfig.headers.get('NO-AUTHORIZATION-TOKEN') === '1') {
    delete requestConfig.headers['NO-AUTHORIZATION-TOKEN'];
  } else {
    let token = '';
    const tokenLocal = localStorage.getItem('authToken');
    const tokenSession = sessionStorage.getItem('authToken');

    if (tokenSession) {
      token = tokenSession;
    } else if (tokenLocal) {
      token = tokenLocal;
    }
    if (isMobile) {
      let mobileAuthToken = '';
      try {
        mobileAuthToken = await secureStorageGet({ key: 'authToken' }); // TODO optimize
      } catch (error) {
        console.error('Capacitor Secure Storage has no AuthToken', error);
      }
      token = mobileAuthToken;
    }

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    } else if (localStorage.getItem('SC-USER-ID')) {
      config.headers['SC-USER-ID'] = localStorage.getItem('SC-USER-ID');
    } else {
      console.log(`No auth request. (${config.url})`);
    }
  }

  return requestConfig;
}
